// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e9bed525","498":"9274d864"}[chunkId] + ".chunk.js";
};